<template>
  <div id="app">
	<!-- 头部 -->
    <header-con v-show="$route.meta.isHeader"></header-con>
    <router-view/>
	<!-- 底部 -->
	<footers v-show="$route.meta.isFooter"></footers>
	<!-- 机器人 -->
	<service></service>
  </div>
</template>

<script>
import headerCon from "./components/header.vue"
import footers from "./components/footer.vue"
import service from "./components/service.vue"

export default {
  name: 'App',
	components:{
		headerCon,footers,service
	}
}
</script>

<style>
#app {font-family: 'MicrosoftYaHei', Helvetica, Arial, sans-serif;-webkit-font-smoothing: antialiased;-moz-osx-font-smoothing: grayscale;color:#333333;}
.box{width: 12.8rem;margin: 0 auto;}

/* 标题 */
.title{width: 100%;height: 5.9rem;background-size: 100% 100%;padding-top: 1.78rem;}
.title-det{padding-top: 1.1rem;height: 5.4rem;}
.title h1{font-size: .9rem;text-align: center;color: #FFFFFF;font-family:Adobe Heiti Std R;margin-bottom: .82rem;}
.title .h1-det{text-align: left;}
.title p{color: #FFFFFF;text-align: center;font-size: .3rem;line-height: .4rem;}
.title .p-det{width: 8.4rem;text-align: left;}
</style>



// WEBPACK FOOTER //
// src/App.vue